import { PipeTransform } from "@node_modules/@angular/core";

export class IecCablesize {

}


export class Model {
  InsulationId: number;
  ConductorId: number;
  CoreId: number;
  PhaseId: number;
  ActiveId: number;
  NeutralId: number;
  EarthId: string;
  EarthConductorId: number;
  MethodIndex: number;
  InstallTableId: number;
  WindSpeedId: number;
  ConduitSizeId: number;
}
export class Table22Model {
  Arrangement: number;
  NoOfCircuits: number;
  drf: number;
}
export class Table271Model {
  AmbientTemp: number;
  UseStandard: boolean;
  Insulation: number;
  drf: number;
}
export class Table25Model {
  CableType: number;
  NoOfCircuits: number;
  TouchingType: number;
  InstallType: number;
  Distance: number;
  drf: number;
  Arrangement: number;
}
/* Depth of burial*/
export class Table28Model {
  UseStandard: boolean;
  Depth: number;
  Buried: number;
  drf: number;
}
export class Table29Model {
  UseStandard: boolean;
  Resitivity: number;
  Buried: number;
  drf: number;
}
export class Table23Model {
  CableType: number;
  Installation: number;
  Row: number;
  Cables: number;
  drf: number;
}
export class Table23InstallationModel {
  name: string;
  value: number;
  img: string;
  desc2: string;
  desc: string;
}

export class CustomName implements PipeTransform {
    transform(name: string) {
        let val = name.split(' ')[0];
        let unit = name.split(' ')[1];
        return val + ' ' + unit;
    }
}